import cloudRoute from "./cloud";
import emailRoute from "./email";
import whatsappRoute from "./whatsapp";

export default {
    path: "/",
    component: () => import("../../layout/index.vue"),
    meta: {
        icon: "dashboard",
        title: "Index",
        langKey: "common.dashboard",
        signTab: true,
        uninclude: ["dir"],
    },
    redirect: "/dashboard",
    children: [
        {
            path: "notificationList",
            name: "NotificationList",
            component: () => import("../../views/NotificationList/index.vue"),
            children: [
                {
                    path: "systemNotification",
                    name: "SystemNotification",
                    meta: {
                        title: "common.notice",
                    },
                    component: () => import("../../views/Study/SystemNotification.vue"),
                },
                {
                    path: "announcement",
                    name: "Announcement",
                    meta: {
                        title: "common.noticeandnews",
                    },
                    component: () => import("../../views/Study/Announcement.vue"),
                },
            ],
        },
        {
            path: "/success",
            name: "Success",
            meta: {
                title: "sys.message.success.submit",
            },
            component: () => import("../../views/Success/Index.vue"),
        },
        {
            path: "dashboard",
            name: "Dashboard",
            meta: {
                title: "common.home",
                langKey: "common.dashboard",
            },
            component: () => import("../../views/Home/Dashboard.vue"),
        },
        {
            path: "marketing",
            name: "Marketing",
            meta: {
                title: "sending.customer.group.text",
            },
            component: () => import("../../views/Marketing/index.vue"),
        },
        emailRoute,
        cloudRoute,
        whatsappRoute,
        {
            path: "/messageDetail",
            name: "MessageDetail",
            component: () => import("../../views/Study/MessageDetail.vue"),
        },
    ],
};
